import { AxiosError } from 'axios';
import { appToast } from 'components/Basic/CustomToast';
import { updateEditableFacets } from 'components/tool/Editor/ButtonDiv/api';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export default function useEditFacetQuery() {
	const { uuid, panel, designType } = useSelector((state: RootState) => state.roofData.data);
	const { editableFacets } = useSelector((state: RootState) => state.roofEditData.data);
	const currentEditableFacets = editableFacets.filter(eachSeg => eachSeg.isEdited).map(eachSeg => ({segmentId:eachSeg.segmentId, coordinates: eachSeg.coordinates}));
	return useMutation(
		'update-edited-facet',
		async () => await updateEditableFacets(currentEditableFacets, uuid, panel.key, designType),
		{
			onError(error: AxiosError) {
				const message = 'Something went wrong. Please fix your edits and try again';
				appToast.error(message);
			}
		}
	);
}